import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=35c9d9da&scoped=true&"
import script from "./Robot.vue?vue&type=script&lang=js&"
export * from "./Robot.vue?vue&type=script&lang=js&"
import style0 from "./Robot.vue?vue&type=style&index=0&id=35c9d9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9d9da",
  null
  
)

export default component.exports